/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import { screen_roles } from "../Roles/roles_config";
import { section_roles } from "../Roles/roles_config";

let routes = {
  version : 46,
  drawer : [
    {
      type: "screen",
      name: "User Administration",
      route: "/users",
      config: "/src/configs/screens/screens/settings-config.js",
      roles: ["ROLE_ADMIN"],
      default_params : null,
      component : "users"
    },
    {
      type: "section",
      name: "Configuration",
      id: "setup-config-section",
      roles: ["ROLE_ADMIN"],
      screens: [
        {
          type: "screen",
          name: "Security Adaptors",
          route: "/security-adaptors",
          config: "/src/configs/screens/screens/dal-config.js",
          roles: ["ROLE_ADMIN"],
          default_params : null,
          component : "security_adaptors_list"
        },
        {
          type: "screen",
          name: "Information Channels",
          route: "/ic",
          config: "/src/configs/screens/screens/ira-config.js",
          roles: ["ROLE_ADMIN"],
          default_params : null,
          component : "ic_list"
        },
        {
          type: "screen",
          name: "Edge Services",
          route: "/ws",
          config: "/src/configs/screens/screens/dal-config.js",
          roles: ["ROLE_ADMIN"],
          default_params : null,
          component : "ws_list"
        },
        {
          type: "screen",
          name: "World View Servers",
          route: "/world-view",
          config: "/src/configs/screens/screens/dal-config.js",
          roles: ["ROLE_ADMIN"],
          default_params : null,
          component : "wv_list"
        },
        {
          type: "screen",
          name: "Data Rendering Services",
          route: "/drl",
          config: "/src/configs/screens/screens/dal-config.js",
          roles: ["ROLE_ADMIN"],
          default_params : null,
          component : "drl_list"
        },
        {
          type: "screen",
          name: "Workflows",
          route: "/workflows",
          config: "/src/configs/screens/screens/dal-config.js",
          roles: ["ROLE_ADMIN"],
          default_params : null,
          component : "workflows"
        },
        {
          type: "screen",
          name: "Events",
          route: "/events",
          config: "/src/configs/screens/screens/dal-config.js",
          roles: ["ROLE_ADMIN"],
          default_params : null,
          component : "events"
        },
        {
          type: "screen",
          name: "Scripts",
          route: "/scripts",
          config: "/src/configs/screens/screens/dal-config.js",
          roles: ["ROLE_ADMIN"],
          default_params : null,
          component : "scripts"
        },
        {
          type: "screen",
          name: "Display Configuration",
          route: "/uiconfig",
          config: "/src/configs/screens/screens/dal-config.js",
          roles: ["ROLE_ADMIN"],
          default_params : null,
          component : "uiconfig"
        },
        
      ],
    },
    {
      type: "section",
      name: "Operations",
      id: "operations",
      roles: ["ROLE_ADMIN", "ROLE_L1"],
      screens : [
        {
          type: "section",
          name: "Cognitive Search",
          id: "search",
          roles: ["ROLE_ADMIN", "ROLE_L1"],
          screens : [
            {
              type: "screen",
              name: "Search",
              route: "/search",
              config: "/src/configs/screens/screens/ira-config.js",
              roles: ["ROLE_ADMIN", "ROLE_L1"],
              default_params : null,
              component : "search"
            }
          ]
        },
        {
          type: "screen",
          name: "Theme Discovery",
          route: "/theme-distribution",
          config: "/src/configs/screens/screens/dal-config.js",
          roles: ["ROLE_ADMIN"],
          default_params : null,
          component : "theme_distribution"
        },
        {
          type: "section",
          name: "Data Quality Management",
          id: "dqm",
          roles: ["ROLE_ADMIN", "ROLE_L1"],
          screens : [
            {
              type: "screen",
              name: "Intelligent Field Consolidation",
              route: "/ifc",
              config: "/src/configs/screens/screens/dal-config.js",
              roles: ["ROLE_ADMIN", "ROLE_L1"],
              default_params : null,
              component : "ifc"
            },
            {
              type: "screen",
              name: "Intelligent Row Consolidation",
              route: "/irc",
              config: "/src/configs/screens/screens/dal-config.js",
              roles: ["ROLE_ADMIN", "ROLE_L1"],
              default_params : null,
              component : "irc"
            },
            {
              type: "section",
              name: "Prevent",
              id: "prevent",
              roles: ["ROLE_ADMIN", "ROLE_L1"],
              screens : []
            }
          ]
        },
        {
          type: "screen",
          name: "PII Detection",
          route: "/pii",
          config: "/src/configs/screens/screens/dal-config.js",
          roles: ["ROLE_ADMIN", "ROLE_L1"],
          default_params : null,
          component : "pii"
        },
      ]
    },
    {
      type: "section",
      name: "Cases",
      id: "cases",
      roles: ["ROLE_L1", "ROLE_ADMIN"],
      screens : []
    },
    {
      type: "section",
      name: "Analytics",
      id: "analytics",
      roles: ["ROLE_ADMIN"],
      screens: [
        {
          type: "screen",
          name: "Information Channel",
          route: "/ic-dashboard",
          config: "/src/configs/screens/screens/queue-config.js",
          roles: ["ROLE_ADMIN"],
          default_params : null,
          component : "ic_dashboard"
        },
        {
          type: "screen",
          name: "Script Statistics",
          route: "/bot-stats",
          config: "/src/configs/screens/screens/queue-config.js",
          roles: ["ROLE_ADMIN"],
          default_params : null,
          component : "bot_stats"
        },
        // {
        //   type: "screen",
        //   name: "Billing Statistics",
        //   route: "/dashboard_stats",
        //   config: "/src/configs/screens/screens/queue-config.js",
        //   roles: ["ROLE_ADMIN"],
        //   default_params : null,
        //   component : "dashboard_stats"
        // }
      ],
    },
    {
      type: "section",
      name: "Links",
      id: "links",
      roles: ["ROLE_L1", "ROLE_ADMIN"],
      screens : []
    },
    {
      type: "screen",
      name: "About",
      route: "/about",
      config: "/src/configs/screens/screens/about-config.js",
      roles: ["ROLE_L1", "ROLE_ADMIN"],
      default_params : null,
      component : "about"
    },
  ],
  internal : [
    {
      type: "screen",
      name: "Home",
      route: "/",
      config: "/src/configs/screens/screens/about-config.js",
      roles: ["ROLE_L1", "ROLE_ADMIN"],
      default_params : null,
      component : 'home'
    },
    {
      type: "screen",
      name: "Create IC",
      route: "/create-ic",
      config: "/src/configs/screens/screens/about-config.js",
      roles: ["ROLE_ADMIN"],
      default_params : null,
      component : "create_ic"
    },
    {
      type: "screen",
      name: "Create Workflow",
      route: "/create-workflow",
      config: "/src/configs/screens/screens/about-config.js",
      roles: ["ROLE_ADMIN"],
      default_params : null,
      component : "create_workflow"
    },
    {
      type: "screen",
      name: "Test Screen",
      route: "/test-screen",
      config: "/src/configs/screens/screens/about-config.js",
      roles: ["ROLE_ADMIN"],
      default_params : null,
      component : "test"
    },
    {
      type: "screen",
      name: "Proxy Screen",
      route: "/proxy-screen",
      config: "/src/configs/screens/screens/about-config.js",
      roles: ["ROLE_ADMIN", "ROLE_L1"],
      default_params : null,
      component : "proxy"
    },
    {
      type: "screen",
      name: "Proxy Screen",
      route: "/proxy-screen",
      config: "/src/configs/screens/screens/about-config.js",
      roles: ["ROLE_ADMIN", "ROLE_L1"],
      default_params : null,
      component : "proxy"
    },
    {
      type: "screen",
      name: "DQM Dashboard",
      route: "/dqm_dashboard",
      config: "/src/configs/screens/screens/about-config.js",
      roles: ["ROLE_ADMIN", "ROLE_L1"],
      default_params : null,
      component : "dqm_dashboard"
    },
    {
      type: "screen",
      name: "DQM Dashboard Config",
      route: "/dqm_dashboard_config",
      config: "/src/configs/screens/screens/about-config.js",
      roles: ["ROLE_ADMIN", "ROLE_L1"],
      default_params : null,
      component : "dqm_dashboard_config"
    }
  ]
}


export default routes;
